// src/components/layout/Layout.jsx

import { useState } from 'react';
import Sidebar from './Sidebar';
import MobileHeader from './MobileHeader';

const Layout = ({ children }) => {
  // Состояние, отвечающее за видимость сайдбара на мобильных устройствах.
  // По умолчанию он скрыт (false).
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-slate-900 text-gray-200">
      
      {/* 
        Сайдбар теперь всегда рендерится, но его видимость управляется через props.
        - `isOpen`: определяет, должен ли сайдбар быть видимым.
        - `onClose`: функция, которую сайдбар может вызвать (например, при нажатии на крестик),
          чтобы сообщить Layout, что его нужно закрыть.
      */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col overflow-hidden">
        
        {/* 
          Мобильный header, который виден только на маленьких экранах.
          - `onMenuClick`: функция, которая вызывается при нажатии на "бургер".
            Она меняет состояние в Layout, чтобы открыть сайдбар.
        */}
        <MobileHeader onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Основной контент страницы */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
          {children}
        </main>
      </div>

      {/* 
        Оверлей для затемнения. Появляется только когда сайдбар открыт
        и только на экранах меньше `lg`. При клике на него сайдбар закрывается.
      */}
      {isSidebarOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black opacity-50 z-20"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default Layout;